import styled from 'styled-components';

import { Popper } from '@mui/material';
import { BaseStyle } from '@nhl/nhl-breakaway-ui';

export const ActionPopper = styled(Popper)`
    ${BaseStyle.Mixins.fontStyles.ui['10m']}

    border-radius: 4px;
    padding: 1em;
    z-index: 100;
    box-shadow: ${BaseStyle.Mixins.utility.fadedBoxShadow};
    background-color: ${({ theme }) => theme.Surface.primary};
    color: ${({ theme }) => theme.Text.primary};
`;

export const LinkContainer = styled.button`
    cursor: pointer;

    svg {
        fill: none;
        width: 35px;
        height: 34px;
    }

    circle {
        stroke: ${({ theme }) => theme.Text.secondary};
    }

    path {
        fill: ${({ theme }) => theme.Text.secondary};
    }

    &:hover {
        circle {
            stroke: ${({ theme }) => theme.Text.primary};
        }

        path {
            fill: ${({ theme }) => theme.Text.primary};
        }
    }
`;
